import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function Hero() {
  const scrollToCTA = () => {
    document.getElementById('final-cta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden" data-id="element-99">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-100">
        <div className="order-2 lg:order-1 z-10" data-id="element-101">
          <FadeIn data-id="element-102">
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-6" data-id="element-103">
              The 3:15 AM "Panic Switch": How to Force Your Body Back to Sleep
              in 18 Minutes or Less.
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-104">
            <h2 className="text-lg md:text-xl text-amber-500 font-medium leading-relaxed mb-8" data-id="element-105">
              A Biological "Kill-Switch" for Menopausal Insomnia, Night Sweats,
              and the Exhausting 3 AM Brain Fog—Without Hormone Therapy or
              Melatonin.
            </h2>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-106">
            <Button onClick={scrollToCTA} className="w-full sm:w-auto" data-id="element-107">
              Get The Protocol Now
            </Button>
          </FadeIn>
        </div>

        <div className="order-1 lg:order-2 relative z-10" data-id="element-108">
          <FadeIn delay={0.3} direction="left" data-id="element-109">
            <div className="relative rounded-xl overflow-hidden shadow-glow-lg border border-night-700/50" data-id="element-110">
              <div className="absolute inset-0 bg-gradient-to-tr from-night-900/40 to-transparent z-10 mix-blend-overlay" data-id="element-111"></div>
              <img src="https://cdn.magicpatterns.com/uploads/a328sSw8ne9Pw3m3gSWJLg/heylloyd-image-1776359025055.png" alt="The 3:15 AM Panic Switch on a tablet at night" className="w-full h-auto object-cover" data-id="element-112" />
            </div>
          </FadeIn>
        </div>
      </div>

      {/* Background ambient glow */}
      <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-amber-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-113"></div>
    </section>;
}